import { isDesktop } from '@carboncopyco/mimesis-shared';
import type { eventWithTime } from '@carboncopyco/rrweb-types';
import { getCompressedEvents } from '../../utils/compression';
import {
  getDownloadableResourcesArray,
  replaceLinksInTourJson,
} from '../../utils/toursResources';

export const localise = async ({
  events,
  organizationId,
  tourId,
  blobFilesToBeReplaced,
  fileServiceDynamicLink,
  tabId,
  errorCallback,
}: {
  events: eventWithTime[];
  organizationId: string;
  tourId: number;
  blobFilesToBeReplaced: any;
  fileServiceDynamicLink: string;
  tabId?: number;
  errorCallback: (error: string) => void;
}) => {
  let eventsWithReplacedLinks = '';
  let downloadedResourcesArray = [];

  if (!isDesktop && !tabId) {
    downloadedResourcesArray = await getDownloadableResourcesArray({
      events,
    });
    eventsWithReplacedLinks = replaceLinksInTourJson({
      events,
      resources: downloadedResourcesArray,
      organizationId,
      tourId,
      blobFilesToBeReplaced,
      fileServiceDynamicLink,
    });
  } else {
    eventsWithReplacedLinks = JSON.stringify(events);
  }

  const compressedEvents = getCompressedEvents(
    eventsWithReplacedLinks,
    errorCallback
  );

  return {
    compressedEvents,
    downloadedResourcesArray,
  };
};
